import Constant from '@/common/constant/Constant';
import { MenuItem, TextField, ListSubheader } from '@material-ui/core';
import Utils from '@/common/utils/utils';
import PropTypes from 'prop-types';
import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';
import TelephonePublisherFilter from './TelephonePublisherFilter';
import { tr } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';

Filters.propTypes = {
    viewSelected: PropTypes.any,
    projectInuseDetail: PropTypes.any,
    filterCreator: PropTypes.any,
    filterHelpDesk: PropTypes.any,
    filterHelpDeskNotice: PropTypes.any,
    setFilterCreator: PropTypes.any,
    setFilterHelpDesk: PropTypes.any,
    setFilterHelpDeskNotice: PropTypes.any,
    helpDeskList: PropTypes.any,
}

export default function Filters(props) {
    // Re-render when the translation dictionary loads/extends so tr() text updates.
    useTranslationSubscription();

    const handleOnchangeFilterCreator = (event) => {
        props.setFilterCreator(event.target.value);
    };

    const handleOnchangeFilterHelpDesk = (event) => {
        props.setFilterHelpDesk(event.target.value);
    };

    const handleOnChangeFilterNotice = (event) => {
        let value = event.target.value === 'all' ? '' : event.target.value;
        props.setFilterHelpDeskNotice(value);
    };

    let internalHelpDeskList = props.helpDeskList.filter(
        (item) => item.helpDeskType === Constant.HELPDESK_LIST_TYPE.INTERNAL
    );
    let externalHelpDeskList = props.helpDeskList.filter(
        (item) => item.helpDeskType === Constant.HELPDESK_LIST_TYPE.EXTERNAL
    );

    if (props.viewSelected === Constant.CUSTOMER_SIDE_VIEW.NOTICE_VIEW) {
        const helpDeskIdList = props.helpDeskListInView;
        const internalHelpDeskNoticeList = helpDeskIdList && helpDeskIdList.length ? internalHelpDeskList.filter((helpDesk) => helpDeskIdList.includes(helpDesk.id)) : [];
        const externalHelpDeskNoticeList = helpDeskIdList && helpDeskIdList.length ? externalHelpDeskList.filter((helpDesk) => helpDeskIdList.includes(helpDesk.id)) : [];
        return (
            <div className="qa-filter-wrap" data-cy="ticket-list-filter">
                <div className="qa-filter-group" data-cy="filter-field-frame">
                    <label className="filter-label" data-cy="filter-status-title">{tr('発行プロジェクト')}</label>
                    <div className="filter-input" data-cy="filter-status-selectbox">
                        <TextField
                            className="form-control form-control--wrap form-control--hg32"
                            select
                            variant="outlined"
                            value={props.filterHelpDeskNotice ? props.filterHelpDeskNotice : 'all'}
                            onChange={(e) => handleOnChangeFilterNotice(e)}
                            SelectProps={{
                                MenuProps: {
                                    anchorOrigin: {
                                        vertical: "bottom",
                                        horizontal: "left"
                                    },
                                    getContentAnchorEl: null,
                                    className: "selectDrop"
                                }
                            }}
                        >
                            <MenuItem value="all">{tr('全て')}</MenuItem>
                            {!Utils.isEmptyArray(internalHelpDeskNoticeList) && (
                                <ListSubheader
                                    className="list-sub-header"
                                    color="inherit"
                                    disableSticky
                                    onClickCapture={(e) => e.stopPropagation()}
                                >
                                    {tr('組織内プロジェクト')}
                                </ListSubheader>
                            )}
                            {internalHelpDeskNoticeList?.map((helpDesk) => helpDeskIdList.includes(helpDesk.id) && (
                                <MenuItem key={helpDesk.id} value={helpDesk.id} className="filter-menu-item">
                                    <OverFlowTooltipWithTabsMui value={helpDesk.shortName} />
                                </MenuItem>
                            ))}
                            {!Utils.isEmptyArray(externalHelpDeskNoticeList) && (
                                <ListSubheader
                                    className="list-sub-header"
                                    color="inherit"
                                    disableSticky
                                    onClickCapture={(e) => e.stopPropagation()}
                                >
                                    {tr('組織外プロジェクト')}
                                </ListSubheader>
                            )}
                            {externalHelpDeskNoticeList?.map((helpDesk) => helpDeskIdList.includes(helpDesk.id) && (
                                <MenuItem key={helpDesk.id} value={helpDesk.id} className="filter-menu-item">
                                    <OverFlowTooltipWithTabsMui value={helpDesk.displayName} />
                                </MenuItem>
                            ))}
                        </TextField>
                    </div>
                </div>
            </div>
        )
    }

    if (props.viewSelected === Constant.CUSTOMER_SIDE_VIEW.TELEPHONE_VIEW) {
        return (
            <TelephonePublisherFilter
                filterTelephonePublisher={props.filterTelephonePublisher}
                setFilterTelephonePublisher={props.setFilterTelephonePublisher}
                helpDeskList={props.helpDeskList}
                helpDeskListInView={props.helpDeskListInView}
            />
        );
    }

    return (
        <div className="qa-filter-wrap qa-filter-container" data-cy="ticket-list-filter">
            {props.projectInuseDetail.type !== Constant.PROJECT_TYPE.BASE &&
                props.projectInuseDetail.type !== Constant.PROJECT_TYPE.CUSTOMER && (
                    <div className="qa-filter-group" data-cy="filter-field-frame">
                        <label className="filter-label" data-cy="filter-status-title">{tr('チケット発行者')}</label>
                        <div className="filter-input" data-cy="filter-status-selectbox">
                            <TextField
                                className="form-control form-control--wrap form-control--hg32"
                                select
                                variant="outlined"
                                value={props.filterCreator}
                                onChange={(e) => handleOnchangeFilterCreator(e)}
                                disabled={props.viewSelected === Constant.CUSTOMER_SIDE_VIEW.DRAFT_QA_VIEW}
                                SelectProps={{
                                    MenuProps: {
                                        anchorOrigin: {
                                            vertical: "bottom",
                                            horizontal: "left"
                                        },
                                        getContentAnchorEl: null,
                                        className: "selectDrop"
                                    }
                                }}
                            >
                                {props.viewSelected === Constant.CUSTOMER_SIDE_VIEW.ARCHIVE_QA_VIEW && (
                                    <MenuItem value={Constant.QA_FILTER_CREATOR.ALL}>
                                        <OverFlowTooltipWithTabsMui value={tr('全て')} />
                                    </MenuItem>
                                )}
                                <MenuItem value={Constant.QA_FILTER_CREATOR.ME}>
                                    <OverFlowTooltipWithTabsMui value={tr('自分')} />
                                </MenuItem>
                                <MenuItem value={Constant.QA_FILTER_CREATOR.PROJECT_MEMBER}>
                                    <OverFlowTooltipWithTabsMui value={tr('プロジェクトメンバー')} />
                                </MenuItem>
                            </TextField>
                        </div>
                    </div>
                )}
            <div className="qa-filter-group" data-cy="filter-field-frame">
                <label className="filter-label" data-cy="filter-status-title">{tr('問い合わせ先')}</label>
                <div className="filter-input" data-cy="filter-status-selectbox">
                    <TextField
                        className="form-control form-control--wrap form-control--hg32"
                        select
                        variant="outlined"
                        value={props.filterHelpDesk}
                        onChange={(e) => handleOnchangeFilterHelpDesk(e)}
                        SelectProps={{
                            MenuProps: {
                                anchorOrigin: {
                                    vertical: "bottom",
                                    horizontal: "left"
                                },
                                getContentAnchorEl: null,
                                className: "selectDrop"
                            }
                        }}
                    >
                        <MenuItem value="">&#8203;</MenuItem>
                        {!Utils.isEmptyArray(internalHelpDeskList) && (
                            <ListSubheader
                                className="list-sub-header"
                                color="inherit"
                                disableSticky
                                onClickCapture={(e) => e.stopPropagation()}
                            >
                                {tr('組織内プロジェクト')}
                            </ListSubheader>
                        )}
                        {internalHelpDeskList?.map((helpDesk) => (
                            <MenuItem key={helpDesk.id} value={helpDesk.id} className="filter-menu-item">
                                <OverFlowTooltipWithTabsMui value={helpDesk.displayName} />
                            </MenuItem>
                        ))}
                        {!Utils.isEmptyArray(externalHelpDeskList) && (
                            <ListSubheader
                                className="list-sub-header"
                                color="inherit"
                                disableSticky
                                onClickCapture={(e) => e.stopPropagation()}
                            >
                                {tr('組織外プロジェクト')}
                            </ListSubheader>
                        )}
                        {externalHelpDeskList?.map((helpDesk) => (
                            <MenuItem key={helpDesk.id} value={helpDesk.id} className="filter-menu-item">
                                <OverFlowTooltipWithTabsMui value={helpDesk.displayName} />
                            </MenuItem>
                        ))}
                    </TextField>
                </div>
            </div>
        </div>
    );
}
